// extracted by mini-css-extract-plugin
module.exports = {"container":"Preview_container__3PXyj","content":"Preview_content__GGUpZ","title":"Preview_title__13nR9","boxView":"Preview_boxView__tlxRR"};